import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { ICompanyUpdateRequest } from "../interface/requests/ICompany";
import { ICompanyMemberResponse, IPermissionMemberResponse } from "../interface/responses/ICompanyResponses";
import { IGetCompanyMembersParams } from "@/core/redux/types/company-member";

class CompanyService {
  constructor() {}

  public async getCompany() {
    const response = await httpClient.get(API_ROUTES.Company.company);
    return response;
  }

  public async updateCompany(id: string, data: ICompanyUpdateRequest) {
    const response = await httpClient.patch(API_ROUTES.Company.update(id), data);
    return response;
  }

  public async updateCompanyLogo(id: string, image: File) {
    const formData = new FormData();
    formData.append('companyLogo', image);
    const response = await httpClient.postMultipart(API_ROUTES.Company.updateLogo(id), formData);
    return response;
  }

  public async getCompanyMembers(params: IGetCompanyMembersParams) {
    const { companyId, offset = 0, limit = 10, search, sortBy } = params;
    
    const queryParams = new URLSearchParams();
    queryParams.append('offset', offset.toString());
    queryParams.append('limit', limit.toString());
    
    if (search) {
      queryParams.append('search', search);
    }
    
    if (sortBy) {
      queryParams.append('sortBy', sortBy);
    }
    
    const url = `${API_ROUTES.Company.members(companyId)}?${queryParams.toString()}`;
    const response = await httpClient.get<ICompanyMemberResponse>(url);
    return response;
  }

  public async getPermissionMember(userId: string, params?: {
    offset?: number;
    limit?: number;
    sortBy?: string;
    search?: string;
  }) {
    const { offset = 0, limit = 30, sortBy = 'createdAt', search } = params || {};
    
    const queryParams = new URLSearchParams();
    queryParams.append('offset', offset.toString());
    queryParams.append('limit', limit.toString());
    queryParams.append('sortBy', sortBy);
    queryParams.append('includeCompanyMember', 'true'); // Request companyMember data
    
    if (search) {
      queryParams.append('search', search);
    }
    
    const url = `${API_ROUTES.SpecPermission.user(userId)}?${queryParams.toString()}`;
    const response = await httpClient.get<IPermissionMemberResponse>(url);
    return response;
  }

  public async deletePermissionMember(permissionId: string) {
    const response = await httpClient.delete(API_ROUTES.SpecPermission.delete(permissionId));
    return response;
  }
}

export const companyService = new CompanyService();
export default CompanyService;